module.exports = __webpack_public_path__ + "img/Hypoxia-LICA_GSE146409.37d85566.png";